/*
 * collection-product-list.js
 * JS zur Section sections/collection-product-list.liquid
 * - holt Produkte per fetch von der echten Collection-URL (view=cplNN)
 * - nutzt den echten Debutify-Filter-Drawer (section_id=dbtfy-collection-filters)
 *   und faengt dessen Klicks in der Capture-Phase ab, statt die Seite zu wechseln
 * Stand: 29.07.2026
 */
(function () {
  var FILTER_SECTION_ID = 'dbtfy-collection-filters';

  function initCpl(root) {
    if (!root || root.dataset.cplInit === '1') return;
    root.dataset.cplInit = '1';

    var collectionUrl = root.dataset.collectionUrl;
    if (!collectionUrl) return;

    var viewName = root.dataset.view;
    var widthClasses = (root.dataset.widthClasses || '').split(/\s+/).filter(Boolean);

    var gridBox = root.querySelector('[data-cpl-grid]');
    var listBox = root.querySelector('[data-cpl-list]');
    var emptyEl = root.querySelector('[data-cpl-empty]');
    var loaderEl = root.querySelector('[data-cpl-loader]');
    var resultsEl = root.querySelector('[data-cpl-results]');
    var moreBtn = root.querySelector('[data-cpl-more]');
    var sortSelect = root.querySelector('[data-cpl-sort]');
    var filterBtn = root.querySelector('[data-cpl-filter-btn]');
    var filterCount = root.querySelector('[data-cpl-filter-count]');
    var layoutButtons = [].slice.call(root.querySelectorAll('[data-cpl-layout]'));
    var viewAllLink = root.querySelector('[data-cpl-viewall]');

    var page = 1;
    var busy = false;
    var drawerLoaded = false;
    var drawerReq = 0;
    var changeTimer = null;

    function drawerEl() { return document.getElementById('dbtfyCollectionFilter'); }

    // Oeffnen/Schliessen mit den gleichen Klassen wie das Theme-Drawer-JS.
    // Eigene Implementierung, weil das Theme seine Handler nur an Drawer bindet,
    // die beim Seitenaufbau schon im DOM sind - unserer kommt per fetch dazu.
    function openDrawer() {
      var d = drawerEl();
      if (!d) return;
      d.classList.add('js-drawer-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('js-drawer-open', 'js-drawer-open-left');
    }

    function closeDrawer() {
      var d = drawerEl();
      if (d) {
        d.classList.remove('js-drawer-open');
        d.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-left');
    }

    function drawerIsOpen() {
      var d = drawerEl();
      return !!(d && d.classList.contains('js-drawer-open'));
    }

    function activeTags() {
      var d = drawerEl();
      if (!d) return [];
      return [].slice.call(d.querySelectorAll('input[type="checkbox"]'))
        .filter(function (b) { return b.checked; })
        .map(function (b) { return b.value; });
    }

    function tagPath() {
      var t = activeTags();
      return t.length ? '/' + t.map(encodeURIComponent).join('+') : '';
    }

    function productsUrl(targetPage) {
      var params = [];
      if (viewName) params.push('view=' + encodeURIComponent(viewName));
      if (sortSelect && sortSelect.value) params.push('sort_by=' + encodeURIComponent(sortSelect.value));
      if (targetPage > 1) params.push('page=' + targetPage);
      return collectionUrl + tagPath() + '?' + params.join('&');
    }

    function drawerUrl() {
      return collectionUrl + tagPath() + '?section_id=' + FILTER_SECTION_ID;
    }

    function fixGridItem(el) {
      el.className = el.className.split(/\s+/).filter(function (c) {
        return c && !/^(large|medium|small)--/.test(c);
      }).concat(widthClasses).join(' ');
      return el;
    }

    function setLoading(on) {
      busy = on;
      if (resultsEl) resultsEl.classList.toggle('is-loading', on);
      if (loaderEl) loaderEl.hidden = !on;
      if (moreBtn) moreBtn.disabled = on;
      if (sortSelect) sortSelect.disabled = on;
    }

    function afterInject() {
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
      try { if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges(); } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: root.dataset.sectionId }
        }));
      } catch (e) {}
    }

    function syncUi() {
      var tags = activeTags();
      if (filterCount) {
        filterCount.hidden = tags.length === 0;
        filterCount.textContent = tags.length ? '(' + tags.length + ')' : '';
      }
      if (viewAllLink) {
        var base = viewAllLink.dataset.baseHref || collectionUrl;
        viewAllLink.href = tags.length ? collectionUrl + tagPath() : base;
      }
    }

    function loadProducts(targetPage, append) {
      setLoading(true);

      return fetch(productsUrl(targetPage), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('[data-cpl-src]');
          var srcItems = src ? [].slice.call(src.children) : [];
          var srcHasNext = src ? src.getAttribute('data-has-next') === 'true' : false;

          var gridItems = srcItems.filter(function (el) { return el.classList.contains('grid-view'); });
          var listItems = srcItems.filter(function (el) { return el.classList.contains('list-view'); });

          gridItems.forEach(fixGridItem);
          listItems.forEach(function (el) { el.removeAttribute('hidden'); });

          if (gridBox) {
            if (!append) gridBox.innerHTML = '';
            gridItems.forEach(function (el) { gridBox.appendChild(el); });
          }
          if (listBox) {
            if (!append) listBox.innerHTML = '';
            listItems.forEach(function (el) { listBox.appendChild(el); });
          }

          page = targetPage;

          var totalVisible = gridBox ? gridBox.children.length : (listBox ? listBox.children.length : 0);
          if (emptyEl) emptyEl.hidden = totalVisible !== 0;
          if (moreBtn) moreBtn.hidden = !srcHasNext;

          setLoading(false);
          afterInject();
        })
        .catch(function (err) {
          setLoading(false);
          if (window.console) console.warn('[collection-product-list] Produkte laden fehlgeschlagen:', err);
        });
    }

    function clearBoxes(scope) {
      [].slice.call(scope.querySelectorAll('input[type="checkbox"]')).forEach(function (b) { b.checked = false; });
    }

    function syncClearButtons(d) {
      [].slice.call(d.querySelectorAll('.dbtfy-filter-group')).forEach(function (g) {
        var any = g.querySelector('input[type="checkbox"]:checked');
        var c = g.querySelector('.filter-clear');
        if (c) c.hidden = !any;
      });
      var all = d.querySelector('.filter-clear-all');
      if (all) all.hidden = !d.querySelector('input[type="checkbox"]:checked');
    }

    // Klicks im Drawer abfangen, bevor das Theme-JS die Seite wechselt (Capture-Phase)
    function bindDrawer(d) {
      d.addEventListener('change', function (e) {
        var box = e.target && e.target.closest ? e.target.closest('input[type="checkbox"]') : null;
        if (!box) return;
        e.stopPropagation();
        onFilterChange();
      }, true);

      d.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;

        if (e.target.closest('.js-drawer-close')) {
          e.preventDefault();
          e.stopPropagation();
          closeDrawer();
          return;
        }

        if (e.target.closest('.filter-clear-all')) {
          e.preventDefault();
          e.stopPropagation();
          clearBoxes(d);
          onFilterChange();
          return;
        }

        var groupClear = e.target.closest('.filter-clear');
        if (groupClear) {
          e.preventDefault();
          e.stopPropagation();
          clearBoxes(groupClear.closest('.dbtfy-filter-group') || d);
          onFilterChange();
        }
      }, true);
    }

    function loadDrawer() {
      var req = ++drawerReq;

      return fetch(drawerUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (req !== drawerReq) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('dbtfyCollectionFilter');
          if (!fresh) throw new Error('Drawer-Markup nicht gefunden');

          var old = drawerEl();
          var wasOpen = !!(old && old.classList.contains('js-drawer-open'));
          var oldInner = old ? old.querySelector('.drawer__inner') : null;
          var scrollTop = oldInner ? oldInner.scrollTop : 0;

          if (old && old.parentNode) {
            old.parentNode.replaceChild(fresh, old);
          } else {
            document.body.appendChild(fresh);
            var bd = doc.querySelector('.overlay-backdrop.overlay-drawer');
            if (bd && !document.querySelector('.overlay-backdrop.overlay-drawer')) {
              document.body.appendChild(bd);
            }
          }

          if (wasOpen) {
            fresh.classList.add('js-drawer-open');
            fresh.setAttribute('aria-hidden', 'false');
          }

          var inner = fresh.querySelector('.drawer__inner');
          if (inner && scrollTop) inner.scrollTop = scrollTop;

          bindDrawer(fresh);
          syncClearButtons(fresh);
          syncUi();
          drawerLoaded = true;
        })
        .catch(function (err) {
          if (window.console) console.warn('[collection-product-list] Filter-Drawer laden fehlgeschlagen:', err);
        });
    }

    function onFilterChange() {
      var d = drawerEl();
      if (d) syncClearButtons(d);
      syncUi();

      if (changeTimer) clearTimeout(changeTimer);
      changeTimer = setTimeout(function () {
        loadProducts(1, false);
        loadDrawer(); // Zaehler/Disabled-States aktualisieren, wie auf der Collection Page
      }, 250);
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () { loadProducts(1, false); });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        if (busy) return;
        loadProducts(page + 1, true);
      });
    }

    layoutButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        root.dataset.layout = btn.dataset.cplLayout;
        layoutButtons.forEach(function (b) {
          b.classList.toggle('collection-layout-button--active', b === btn);
        });
        window.dispatchEvent(new Event('scroll'));
      });
    });

    if (filterBtn) {
      filterBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (drawerLoaded) {
          openDrawer();
        } else {
          loadDrawer().then(openDrawer);
        }
      }, true);

      document.addEventListener('click', function (e) {
        if (!drawerIsOpen()) return;
        if (e.target && e.target.classList && e.target.classList.contains('overlay-drawer')) {
          closeDrawer();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawerIsOpen()) closeDrawer();
      });

      // Vorladen, damit der erste Klick sofort oeffnet
      setTimeout(loadDrawer, 700);
    }

    syncUi();
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-section-type="collection-product-list"]')).forEach(initCpl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
